import React from "react";
import RoyaltyList from "components/royaltys/RoyaltyList";

const Royaltys: React.FC = () => {
  return (
    <div>
      <h1 className="text-2xl font-semibold text-gray-900 mb-6">
        Gestione Royalty
      </h1>
      <RoyaltyList />
    </div>
  );
};

export default Royaltys;
